import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    status: {
      marginRight: 5,
      fontWeight: 600,
      color: theme.palette.statuses.completed,
      fontSize: theme.typography.pxToRem(12),
      '&::before': {
        fontFamily: 'Material Icons',
        content: "'done'",
        fontWeight: 600,
        fontSize: theme.typography.pxToRem(12),
        marginRight: 5,
        color: theme.palette.statuses.completed,
      },
    },
  };
});

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      textAlign: 'right',
    },

    primary: {
      color: theme.palette.text.subtitle,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: 600,
      textTransform: 'capitalize',
      textAlign: 'left',
      wordBreak: 'break-word',
    },

    secondary: {
      color: theme.palette.text.primary,
      fontSize: 12,
      fontWeight: 400,
      maxWidth: '60%',
      wordBreak: 'break-word',
      '& span:last-child': {
        display: 'block',
        fontSize: theme.typography.pxToRem(11),
        textTransform: 'capitalize',
      },
    },
  };
});

const listItemsStyles = makeStyles((theme) => {
  return {
    root: {
      width: '100%',
      padding: '0 5px 8px',
      borderBottom: '1px solid #EEE',
      marginBottom: 10,
    },
  };
});

export { useStyles, listTextStyles, listItemsStyles };
